import {Component, Input, OnInit} from '@angular/core';
import {NzModalRef} from 'ng-zorro-antd';
import {ProductsService} from '../../../services';
import moment from 'moment';
import {Router} from '@angular/router';

@Component({
  selector: 'app-modal-passport',
  templateUrl: './modal-passport.component.html',
  styleUrls: ['./modal-passport.component.scss']
})
export class ModalPassportComponent implements OnInit {
  @Input() urlImageProduct;
  @Input() productName;
  @Input() barcodeProduct;
  @Input() productId;

  passports: any = [];
  activePassport = 0;
  passport: any;
  loading = false;
  detail: any;
  listPassportDocument: any = [];

  constructor(public modalRef: NzModalRef<ModalPassportComponent>,
              private productsService: ProductsService,
              private router: Router) { }

  ngOnInit() {
    this.loadPassport();
    this.loadData();
  }

  loadData() {
    // this.productsService.getProductPassport(this.productId).subscribe(res => {
    //   if (res && res.code === 1 && res.data) {
    //     this.detail = res.data;
    //   }
    // });
  }

  onActivePassport(passport, index) {
    this.activePassport = index;
    this.passport = passport;
    this.loadPassportDocument();
  }

  loadPassport() {
    this.productsService.getPassports({
      page: 1,
      pageSize: 1000,
      status: 1
    }).subscribe(res => {
      if (res && res.code === 1) {
        this.passports = res.data;
        if (res.data && res.data.length) {
          this.passport = this.passports[0];
          this.loadPassportDocument();
          this.activePassport = 0;
        }
      }
    });
  }

  loadPassportDocument() {
    this.loading = true;
    const passport = this.passport;
    this.productsService.getPassportByDocument(this.productId, {passportId: passport.id}).subscribe(res => {
      if (res && res.code === 1) {
        this.listPassportDocument = res && res.data ? res.data.map((item, index) => {
          return {
            ...item,
            stt: index + 1,
            documentUrls: item && item.documentUrl && item.documentUrl.length ? item.documentUrl.replace('{', '').replace('}', '').split(',') : []
          };
        }) : [];
      }
    });
  }

  getStatusText(expiredAt) {
    if (!expiredAt) { return ''; }
    if (moment().isAfter(moment(expiredAt, 'DD-MM-YYYY'))) {
      return 'Hết hạn';
    }

    if (moment().isSameOrBefore(moment(expiredAt, 'DD-MM-YYYY'))) {
      return 'Còn hạn';
    }
  }

  onAddDocument() {
    this.router.navigate([`business/products/${this.productId}/documents`]);
    this.modalRef.close();
  }

}
